module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/ChevronBlackLeft-3928d9cda72bf5c2a2450fffaba26e15.png";